import React from 'react';
import Basepage, { BasePageState } from '../Basepage';
import VRPaymentImg from './images/VRPayment-Logo_sRGB.svg';
import bigZahlungen from './images/zahlung_big.jpg';

interface ZahlungState extends BasePageState {}
interface ZahlungModel {}

export default class ZahlungPage extends Basepage<ZahlungState, ZahlungModel> {
  renderChild(): JSX.Element {
    return (
      <div id="zahlung">
        <b>Zahlung</b>
        <br />
        <br />
        <img src={VRPaymentImg} style={{ height: '100px', width: 'auto' }} />
        <br />
        Unsere Zahlungsabwicklung wird von der VR Payment GmbH durchgeführt.
        <br />
        <br />
        Sie können Ihren Einkauf einfach bequem auf Rechnung über TEBA Pay
        bezahlen.
        <br />
        Natürlich ist die Zahlung auch per Kreditkarte, SEPA Lastschrift und PayPal möglich.
        <br />
        <br />
        Sofern Sie von uns ein Kreditlimit bekommen haben, können Sie auch auf
        offene Rechnung bestellen.
        <br />
        Und sind Sie der BAG angeschlossen, bieten wir Ihnen auch die
        Möglichkeit der BAG Abrechnung an.
        <br />
        <br />
        <img src={bigZahlungen} style={{ height: '200px', width: 'auto' }} />
      </div>
    );
  }
  initState(base: BasePageState): ZahlungState {
    let newState: ZahlungState = {
      ...base,
    };

    return newState;
  }
  getApiReqestUrl(checkOnly: boolean): string {
    return this.state.apiBase + '/Standard.php';
  }
  releaseOneCommand(): void {}
  childDidMount(): void {}
  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }

  pageHeaderGetter(): string | null {
    return null;
  }
  pageTitleGetter(): string {
    return 'Zahlung';
  }
  getBreadCrumb(): JSX.Element {
    return <span>Zahlung</span>;
  }
  getType(): string {
    return 'ZahlungPage';
  }
}
